import { useTranslation } from "react-i18next";
import { cn } from "../utils/style";
function SimpleTabs({ tabs, get, set }) {
  const { t } = useTranslation();
  if (!tabs) return null;
  return (
    <div>
      {/* Mobile Select */}
      <div className="sm:hidden mb-6">
        <label htmlFor="tabs" className="sr-only">
          {t("Select a tab")}
        </label>
        <div className="relative">
          <select
            id="tabs"
            name="tabs"
            value={get}
            onChange={(v) => set(v.target.value)}
            className="block w-full appearance-none rounded-2xl border-slate-200 bg-white px-5 py-4 text-sm font-bold text-slate-700 shadow-sm transition-all duration-300 focus:border-primary-500 focus:ring-4 focus:ring-primary-500/10"
          >
            {tabs.map((tab) => (
              <option key={tab.column} value={tab.column}>
                {tab.name}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 end-0 flex items-center px-4 text-slate-400">
            <svg className="h-4 w-4 fill-current" viewBox="0 0 20 20">
              <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
            </svg>
          </div>
        </div>
      </div>

      {/* Desktop Pills */}
      <div className="hidden sm:block">
        <nav
          aria-label="Tabs"
          className="flex items-center gap-2 p-1.5 bg-slate-100/50 rounded-[1.25rem] border border-slate-200/40 w-fit"
        >
          {tabs.map((tab) => {
            const active = tab.column === get;
            return (
              <button
                key={tab.column}
                onClick={() => set(tab.column)}
                className={cn(
                  "relative flex items-center px-5 py-2.5 text-[11px] font-black uppercase tracking-widest cursor-pointer transition-all duration-500 rounded-xl overflow-hidden",
                  active
                    ? "bg-white text-primary-600 shadow-lg shadow-primary-500/5 ring-1 ring-primary-500/10 scale-100"
                    : "text-slate-500 hover:text-slate-900 hover:bg-white/60",
                )}
              >
                <span className="relative z-10">{tab.name}</span>
                {active && (
                  <div className="absolute inset-0 bg-gradient-to-tr from-primary-50/50 to-white pointer-events-none" />
                )}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
export default SimpleTabs;
